import React from 'react';
import Icon from '../../../components/AppIcon';

const ValueProposition = () => {
  const values = [
    {
      id: 1,
      icon: "UtensilsCrossed",
      title: "Authentic Flavors",
      description: "Traditional South Sudanese recipes prepared with love and care"
    },
    {
      id: 2,
      icon: "Clock",
      title: "Fast Delivery",
      description: "Hot, fresh meals delivered to your door within 30-45 minutes"
    },
    {
      id: 3,
      icon: "ShieldCheck",
      title: "Quality Guaranteed",
      description: "Fresh ingredients and strict food safety standards every day"
    },
    {
      id: 4,
      icon: "MessageCircle",
      title: "Easy Ordering",
      description: "Order via WhatsApp or call - simple, fast, and convenient"
    }
  ];

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-background">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            Why Choose Chapati Plus?
          </h2>
          <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
            Freshly made, affordable, and packed with flavor. At Chapati Plus, we serve delicious meals prepared with care, fast service you can rely on, and a taste that keeps you coming back for more. Every bite is made to satisfy.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {values?.map((value) => (
            <div
              key={value?.id}
              className="text-center group"
            >
              <div className="w-16 h-16 md:w-20 md:h-20 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4 md:mb-6 group-hover:bg-primary/20 transition-colors duration-300">
                <Icon
                  name={value?.icon}
                  size={32}
                  color="var(--color-primary)"
                />
              </div>
              <h3 className="text-lg md:text-xl font-bold text-foreground mb-2 md:mb-3">
                {value?.title}
              </h3>
              <p className="text-sm md:text-base text-muted-foreground">
                {value?.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValueProposition;